module.exports = __webpack_public_path__ + "img/close-square.402cf77f.svg";